import { ExpenseItemUpdatePage } from '@/features/expense-item/pages/ExpenseItemUpdatePage'
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/admin/expense-item/$id/update')({
  beforeLoad({ context }) {
    if (!context.authAdapter.can({ permissions: ["expense_item.edit"] })) {
      throw redirect({ to: "/403" });
    }
  },
  component: ExpenseItemUpdatePage,
});
